import React from 'react';
import { Section } from './Section';
import { Button } from './Button';
import { Shield } from 'lucide-react';
import { trackPixel } from '../lib/metaPixel';
export const Oferta = () => {
  const handleAddToCart = () => {
    trackPixel('AddToCart', {
      content_name: 'Botiquín de Emergencia Post-Oficina',
      content_ids: ['48426088661092'],
      content_type: 'product',
      value: 8900,
      currency: 'ARS'
    });
  };
  return <Section id="oferta" className="relative" data-id="element-156">
      <div className="absolute inset-0 bg-radial-glow opacity-40 pointer-events-none" data-id="element-157" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-158">
        <div className="border border-gold p-1 md:p-2 rounded-sm bg-gold/5" data-id="element-159">
          <div className="border border-gold/30 bg-navy-900 p-8 md:p-16 text-center rounded-sm relative overflow-hidden" data-id="element-160">
            {/* Decorative corners */}
            <div className="absolute top-4 left-4 w-8 h-8 border-t-2 border-l-2 border-gold/40" data-id="element-161" />
            <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-gold/40" data-id="element-162" />
            <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-gold/40" data-id="element-163" />
            <div className="absolute bottom-4 right-4 w-8 h-8 border-b-2 border-r-2 border-gold/40" data-id="element-164" />

            <Shield className="mx-auto text-gold mb-6" size={48} strokeWidth={1} data-id="element-165" />

            <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-166">
              Recuperá tu soberanía energética hoy
            </h2>

            <div className="my-10 flex flex-col items-center justify-center" data-id="element-167">
              <span className="text-gray-500 line-through text-xl mb-2" data-id="element-168">
                Valor regular: $22.000 ARS
              </span>
              <div className="flex items-end gap-4 text-gold" data-id="element-169">
                <span className="text-5xl md:text-7xl font-serif font-bold" data-id="element-170">
                  $8.900
                </span>
                <span className="text-xl md:text-2xl pb-2" data-id="element-171">ARS</span>
              </div>
            </div>

            <p className="text-lg text-gray-300 font-light max-w-xl mx-auto mb-10" data-id="element-172">
              Menos de lo que cuesta un combo de hamburguesa, pero con un
              impacto que te va a durar{' '}
              <strong className="text-offwhite font-medium" data-id="element-173">
                toda tu carrera profesional.
              </strong>
            </p>

            <Button onClick={handleAddToCart} href="https://tucentrovital.com/cart/48426088661092:1" className="w-full md:w-auto md:px-16 py-5 text-xl" data-id="element-174">
              ¡QUIERO MI BOTIQUÍN AHORA!
            </Button>

            <p className="mt-6 text-sm text-gray-400 font-light flex items-center justify-center gap-2" data-id="element-175">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-176" />
              Acceso inmediato tras la compra. Tu paz no puede esperar a mañana.
            </p>
          </div>
        </div>
      </div>
    </Section>;
};